import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography, Container } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#f0f4fb',
    textAlign: 'center',
    padding: theme.spacing(8.5, 5, 7.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6, 2, 4),
    },
  },
  title: {
    fontSize: '2rem !important',
    fontWeight: '700 !important',
    color: '#1E293B',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      fontSize: '2.5rem !important',
    },
  },
  titleHighlight: {
    color: '#4361EE',
  },
  tagline: {
    fontSize: '1.125rem',
    fontWeight: '700',
    color: '#1E293B',
    marginBottom: theme.spacing(1),
  },
  subDescription: {
    fontSize: '1.125rem',
    color: '#64748B',
    maxWidth: '800px',
    margin: '0 auto 20px',
    lineHeight: 1.6,
  },
  heroBadges: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '14px',
    flexWrap: 'wrap',
  },
  heroBadgeItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    background: '#fff',
    border: '1.5px solid #d1ddf5',
    borderRadius: '30px',
    padding: '8px 16px',
    fontSize: '13px',
    fontWeight: 600,
    color: '#374151',
    boxShadow: '0 1px 4px rgba(33,82,217,0.06)',
  },
  badgeIcon: {
    width: '20px',
    height: '20px',
    color: '#2152d9',
    flexShrink: 0,
  },
  /* ── SHIELD VISUAL ── */
  shieldSection: {
    padding: theme.spacing(6.5, 5, 5),
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  shieldWrap: {
    position: 'relative',
    width: '220px',
    height: '220px',
  },
  shieldRing: {
    position: 'absolute',
    borderRadius: '50%',
    border: '2px solid rgba(33,82,217,0.15)',
    animation: '$pulseRing 3s ease-out infinite',
  },
  ring1: { inset: '-30px', animationDelay: '0s' },
  ring2: { inset: '-60px', animationDelay: '0.6s' },
  ring3: { inset: '-90px', animationDelay: '1.2s' },
  '@keyframes pulseRing': {
    '0%': { opacity: 0.6, transform: 'scale(0.96)' },
    '50%': { opacity: 0.3, transform: 'scale(1)' },
    '100%': { opacity: 0.6, transform: 'scale(0.96)' },
  },
  shieldInner: {
    position: 'relative',
    zIndex: 1,
    width: '220px',
    height: '220px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const SecurityHero = () => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.root}>
        <Container maxWidth="lg">
          <Typography variant="h1" className={classes.title}>
            Your Security. Our{' '}
            <span className={classes.titleHighlight}>Top Priority.</span>
          </Typography>
          <Typography className={classes.tagline}>
            Yes. 100% Secure. No Social Security Number Required.
          </Typography>
          <Typography className={classes.subDescription}>
            At Plootus, we've built every layer of our platform with your protection in mind.
            Bank-level encryption, read-only access, and zero storage of sensitive credentials.
          </Typography>
          
          <Box className={classes.heroBadges}>
            <Box className={classes.heroBadgeItem}>
              <svg className={classes.badgeIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
              </svg>
              256-bit SSL Encryption
            </Box>
            <Box className={classes.heroBadgeItem}>
              <svg className={classes.badgeIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>
              </svg>
              Read-Only Access
            </Box>
            <Box className={classes.heroBadgeItem}>
              <svg className={classes.badgeIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              AWS Cloud Secured
            </Box>
            <Box className={classes.heroBadgeItem}>
              <svg className={classes.badgeIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/>
              </svg>
              Zero Credential Storage
            </Box>
          </Box>
        </Container>
      </Box>

      {/* ── SHIELD VISUAL ── */}
      {/* <Box className={classes.shieldSection}>
        <Box className={classes.shieldWrap}>
          <Box className={`${classes.shieldRing} ${classes.ring1}`} />
          <Box className={`${classes.shieldRing} ${classes.ring2}`} />
          <Box className={`${classes.shieldRing} ${classes.ring3}`} />
          <Box className={classes.shieldInner}>
            <svg width="220" height="220" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
              <path d="M110 12 L196 50 L196 128 Q196 178 110 206 Q24 178 24 128 L24 50 Z"
                    fill="#2152d9" opacity="0.12"/>
              <path d="M110 20 L188 56 L188 128 Q188 172 110 198 Q32 172 32 128 L32 56 Z"
                    fill="#2152d9" opacity="0.18"/>
              <path d="M110 30 L178 62 L178 126 Q178 164 110 188 Q42 164 42 126 L42 62 Z"
                    fill="#2152d9" opacity="0.9"/>
              <path d="M110 38 L170 68 L170 125 Q170 158 110 180 Q50 158 50 125 L50 68 Z"
                    fill="#1a3fbf" opacity="0.6"/>
              <rect x="90" y="108" width="40" height="32" rx="8" fill="white" opacity="0.95"/>
              <path d="M100 108 Q100 90 110 90 Q120 90 120 108" fill="none" stroke="white" strokeWidth="6" strokeLinecap="round" opacity="0.95"/>
              <circle cx="110" cy="124" r="5" fill="#2152d9"/>
              <rect x="108" y="124" width="4" height="8" rx="2" fill="#2152d9"/>
              <polyline points="86,100 100,115 135,78" fill="none" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" opacity="0.3"/>
            </svg>
          </Box>
        </Box>
      </Box> */}
    </>
  );
};

export default SecurityHero;
